import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';
import DataReactTable from '../../../../ClinicHistory/ClinicHistoryViewIPS/components/SourceDocuments/DataReactTable';
import TableActions from '../../../../ClinicHistory/ClinicHistoryViewIPS/components/SourceDocuments/TableActions';

const PatientsDocuments = ({ id_historia }) => {
    const [loaded, setLoaded] = useState(false);
    const [patientsDocuments, setPatientsDocuments] = useState(null);

    useEffect(() => {
        const getDataFiles = () => {
            setLoaded(true);
            let dataSend = {
                id_historia: parseInt(id_historia),
                id_admision: 0
            };

            console.log(dataSend);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    //setPatientsDocuments(data.contenido);
                    //filterFilesFromNull(data.contenido);
                    createDatateble(data.contenido)
                    setLoaded(false);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        getDataFiles();
    }, [])

    const filterFilesFromNull = (files) => {
        let data = [];
        if (files !== null) {
            files.forEach((file) => {
                if(file.archivos !== null){
                    data.push(file);
                }
            })
        }
        setPatientsDocuments(data);
    }

    const createDatateble = (data) => {
        let filterData = [];
        for (let i = 0; i < data.length; i++) {
            if (data[i].archivos !== null) {
                for (let j = 0; j < data[i].archivos.archivos.length; j++) {
                    filterData.push(data[i].archivos.archivos[j]);
                }
            }
        }
        setData(filterData);
    }

    const setData = (data) => {
        let filterData = [];
        for (let i = 0; i < data.length; i++) {
            filterData[i] = {
                clase: data[i].clase === "1" ? "CONSENTIMIENTO INFORMADO" :
                    data[i].clase === "2" ? "ECOCARDIOGRAMA MODO M" :
                        data[i].clase === "3" ? "ECOCARDIOGRAMA STRESS" :
                            data[i].clase === "4" ? "ELECTROCARDIOGRAMAS" :
                                data[i].clase === "5" ? "FORMULA MEDICA" :
                                    data[i].clase === "6" ? "HISTORIA CLINICA" :
                                        data[i].clase === "7" ? "HOLTER CARDIACO" :
                                            data[i].clase === "8" ? "IMAGENOLOGIA" :
                                                data[i].clase === "9" ? "LABORATORIO CLINICO" :
                                                    data[i].clase === "10" ? "MONITOREO DE PRESION ARTERIAL" :
                                                        data[i].clase === "11" ? "ORDEN MEDICA" :
                                                            data[i].clase === "12" ? "GAMAGRAFIAS" :
                                                            data[i].clase === "13" ? "RESONANCIA NUCLERA MAGNETICA" : 
                                                            data[i].clase === "14" ? "DOCUMENTO DE IDENTIDAD" :
                                                            data[i].clase === "15" ? "AUTORIZACION" :
                                                            data[i].clase === "16" ? "OTROS" :
                                                            "",
                fecha: data[i].fecha,
                hora: data[i].hora,
                nombre: data[i].fileName,
                usuario: typeof data[i].usuario !== 'undefined' ? data[i].usuario : "",
                descripcion: data[i].descripcion,
                ruta: data[i].ruta
            }
        }
        setPatientsDocuments(filterData);
        setLoaded(false);
    }

    const reactTableData = {
        tableHeaderData: [
            {
                Header: 'TIPO',
                accessor: 'clase',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'FECHA',
                accessor: 'fecha',
            },
            {
                Header: 'HORA',
                accessor: 'hora',
            },
            {
                Header: 'NOMBRE',
                accessor: 'nombre',
            },
            {
                Header: 'DESCRIPCIÓN',
                accessor: 'descripcion',
            },
        ],
        tableRowsData: patientsDocuments
    };

    const LoadInfo = () => {

        return (<DataReactTable
            title={''}
            reactTableData={reactTableData}
            ReactTableActions={TableActions}
        />)
    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>DOCUMENTOS</b></h4>
                                </div>
                            </div>
                        </Row>
                        <Row>
                        {
                                loaded ?
                                    <div className="text-center">
                                        <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                    </div>
                                    : patientsDocuments ?
                                        <Fragment>
                                            <LoadInfo />
                                        </Fragment>
                                        :
                                        <div className="info-empty-profile">
                                            <h5>No se ha generado ningún Documento</h5>
                                        </div>
                            }
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default PatientsDocuments